import "./style.scss";
import $ from 'jquery';

$(document).ready(function () {

    if ($('.tabs-block').length) {
        console.log("test");

        $('.tabs-block__nav_item').each(function () {
            $(this).on("click", function () {
                var tabElement = $(this).attr('tab-data');
                $('.tabs-block__nav_item').removeClass('active');
                $(this).addClass('active');
                $('.tabs-block__content_single').removeClass('active');
                $('.tabs-block__content_single[tab-data="' + tabElement + '"]').addClass('active');
            });
        });
    }

});